export default {
      id: "success-usage",
      viewBox: "0 0 230.453 230.453",
      url: "/assets/svg/" + "sprite.svg#success-usage",
      toString: function () {
        return this.url;
      }
    }